import { Module } from "vuex";
import { RootState } from "@/stores";
import * as actions from "./actions";
import mutations from "./mutations";
import {
  BankSecretRow,
  ClientInfo,
  ClientListItem,
  UserListItem,
  ClientSecret,
  Transaction,
} from "@/types";
import {
  GetClientSearchType,
  GetClientSearchTypeMap,
} from "@/proto/admin/all_pb";
import { kycApplicationType } from "@/utils/client-utils";

export interface ClientState {
  currentClient: ClientInfo | null;
  currentIntegration: ClientSecret | null;
  clientList: ClientListItem[];
  userList: UserListItem[];
  transactions: Transaction[];
  integrations: BankSecretRow[];
  currentTab: string | null;
  total: number;
  page: number;
  pageSize: number;
  filterConfig: {
    isActive: boolean;
    filters: {
      countries: string;
      access: "all" | "live" | "sandbox";
      kycApplication:
        | "all"
        | kycApplicationType.APPLYING
        | kycApplicationType.NOT_APPLYING;
    };
  };
  searchConfig: {
    searchtype: GetClientSearchTypeMap[keyof GetClientSearchTypeMap];
    searchtext: string;
  };
}

export const getInitialState = (): ClientState => ({
  currentClient: null,
  currentIntegration: null,
  total: 0,
  clientList: [],
  userList: [],
  transactions: [],
  integrations: [],
  // Persist current tab inside Client Details when navigate between pages
  currentTab: null,
  // Persist client list filters
  filterConfig: {
    isActive: false,
    filters: {
      countries: "",
      access: "all",
      kycApplication: "all",
    },
  },
  // Persist client list search
  searchConfig: {
    searchtype: GetClientSearchType.ORGANIZATION,
    searchtext: "",
  },
  page: 1,
  pageSize: 10,
});

const initialState: ClientState = getInitialState();

const client: Module<ClientState, RootState> = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};

export default client;
